import { docodeHexResponse } from "../../_common/common.utils";
import PerforamanceReportTypes from "./performanceReport.types";
const INITIAL_STATE: any = {
  performanceReportFetchResponseArr: [],
  performanceReportDatewiseResponseArr: [],
  performanceReportFetchResponse: null,
  performanceReportDateWiseResponse: null,
  performanceReportExportResponse: null,
  performanceReportExportResponseArr: [],
  exportPerformanceReportStatus: "",
};
const performanceReportReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_SUCCESS:
      return {
        ...state,
        performanceReportFetchResponse: action.payload,
        performanceReportFetchResponseArr: docodeHexResponse(
          action.payload,
          "PerformanceReportKey",
        ),
      };

    case PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_FAILURE:
      return {
        ...state,
        performanceReportFetchResponse: action.payload,
        performanceReportFetchResponseArr: [],
      };

    case PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_RESPONSE_CHANGED:
      return { ...state, performanceReportFetchResponse: null };
    case PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_SUCCESS:
      return {
        ...state,
        performanceReportExportResponse: action.payload,
        performanceReportExportResponseArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportPerformanceReportStatus: "Success",
      };

    case PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_FAILURE:
      return {
        ...state,
        performanceReportExportResponse: action.payload,
        performanceReportExportResponseArr: [],
        exportPerformanceReportStatus: "Failure",
      };

    case PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_CHANGED:
      return {
        ...state,
        performanceReportExportResponse: null,
        exportPerformanceReportStatus: "",
      };

    default:
      return state;
  }
};
export default performanceReportReducer;
